<div class="dynamic-content" #bannerUnitCarouselRef></div>
